export const biPageData = {
  hero: {
    title: 'Business Intelligence Solutions',
    description:
      'Transform your raw data into powerful insights with our comprehensive business intelligence platform. Make data-driven decisions that drive growth and optimize your operations.',
  },
  overview: {
    title: 'Why Business Intelligence Matters',
    paragraphs: [
      "In today's competitive landscape, businesses that leverage data effectively gain a significant advantage. Our Business Intelligence solutions transform your scattered data into actionable insights that drive strategic decisions.",
      'We help organizations break down data silos, create unified reporting systems, and establish real-time monitoring capabilities that keep you ahead of market trends and operational challenges.',
      'From executive dashboards to operational reports, our BI solutions scale with your business needs and provide the visibility required to optimize performance across all departments.',
    ],
    stats: [
      { number: '40%', label: 'Average Increase in Decision Speed' },
      { number: '25%', label: 'Cost Reduction Through Insights' },
      { number: '60%', label: 'Improvement in Data Accuracy' },
      { number: '90%', label: 'Client Satisfaction Rate' },
    ],
  },
  services: {
    title: 'Our BI Services',
    items: [
      {
        icon: '📊',
        title: 'Interactive Dashboards',
        description:
          'Create stunning, interactive dashboards that provide real-time insights into your business performance.',
        features: [
          'Real-time data visualization',
          'Customizable layouts',
          'Mobile-responsive design',
          'Drill-down capabilities',
          'Role-based access control',
        ],
        cta: 'Download Sample Report',
      },
      {
        icon: '📈',
        title: 'Automated Reporting',
        description: 'Streamline your reporting process with automated, scheduled reports delivered to stakeholders.',
        features: [
          'Scheduled report delivery',
          'Multiple output formats',
          'Exception-based alerts',
          'Custom report templates',
          'Email and SMS notifications',
        ],
      },
      {
        icon: '⚡',
        title: 'Real-time Analytics',
        description: 'Monitor your business performance in real-time with live data streams and instant alerts.',
        features: [
          'Live data streaming',
          'Instant alert systems',
          'Performance monitoring',
          'Anomaly detection',
          'Threshold-based notifications',
        ],
      },
      {
        icon: '🎯',
        title: 'KPI Monitoring',
        description: 'Track and optimize your key performance indicators with comprehensive monitoring solutions.',
        features: [
          'Custom KPI frameworks',
          'Benchmark comparisons',
          'Trend analysis',
          'Goal tracking',
          'Performance scorecards',
        ],
      },
    ],
  },
  process: {
    title: 'Our Implementation Process',
    steps: [
      { number: 1, title: 'Discovery & Assessment', description: 'We analyze your current data landscape, identify key stakeholders, and understand your specific business intelligence requirements.' },
      { number: 2, title: 'Data Integration', description: 'Connect and consolidate data from multiple sources including databases, APIs, cloud services, and legacy systems.' },
      { number: 3, title: 'Dashboard Design', description: 'Create intuitive, user-friendly dashboards tailored to different user roles and business functions within your organization.' },
      { number: 4, title: 'Testing & Validation', description: 'Thoroughly test all components, validate data accuracy, and ensure optimal performance across different devices and browsers.' },
      { number: 5, title: 'Deployment & Training', description: 'Deploy the solution to your environment and provide comprehensive training to ensure your team can maximize its potential.' },
      { number: 6, title: 'Ongoing Support', description: 'Provide continuous monitoring, maintenance, and optimization to ensure your BI solution evolves with your business needs.' },
    ],
  },
  technologies: {
    title: 'Technologies We Use',
    items: [
        { icon: '📊', name: 'Power BI' },
        { icon: '📈', name: 'Tableau' },
        { icon: '☁️', name: 'AWS QuickSight' },
        { icon: '🔥', name: 'Apache Spark' },
        { icon: '🐍', name: 'Python' },
        { icon: '📋', name: 'SQL Server' },
        { icon: '🔗', name: 'ETL Tools' },
        { icon: '📱', name: 'Mobile BI' },
    ],
  },
  gallery: {
    title: 'Dashboard Gallery',
    description: 'Explore examples of our interactive business intelligence dashboards in action',
    items: [
        { img: '/dashboard1.jpeg', alt: 'Food Stores Performance Dashboard', title: 'Food Stores Performance Dashboard', description: 'Comprehensive retail analytics tracking weekly revenue (₹1.2M), food waste percentage, freshness scores, and inventory turnover across store categories' },
        { img: '/dashboard2.jpeg', alt: 'Healthcare Performance Dashboard', title: 'Healthcare Performance Dashboard', description: 'Healthcare analytics monitoring patient satisfaction (4.6/5), average wait times, bed occupancy rates, and department performance metrics' },
        { img: '/dashboard3.jpeg', alt: 'Hypermarket Performance Dashboard', title: 'Hypermarket Performance Dashboard', description: 'Retail operations dashboard tracking daily revenue (₹8.5M), footfall count, customer flow patterns, and department-wise performance analysis' },
        { img: '/dashboard4.jpeg', alt: 'Retail Performance Dashboard', title: 'Retail Performance Dashboard', description: 'Multi-store retail analytics featuring monthly revenue (₹2.8M), conversion rates, customer segmentation, and profit margin trends analysis' },
        { img: '/dashboard5.jpeg', alt: 'School Transportation Efficiency Dashboard', title: 'School Transportation Dashboard', description: 'Transportation management system tracking cost per student ($4.20), on-time performance (94%), vehicle utilization, and route efficiency metrics' },
    ],
  },
  cta: {
    title: 'Ready to Transform Your Data into Insights?',
    description: "Let's discuss how our Business Intelligence solutions can help your organization make better, faster decisions.",
    buttonText: 'Get Started Today',
  },
};
